import { extend } from "vee-validate";
import { required } from "vee-validate/dist/rules";
import { configure } from 'vee-validate';

extend("required", {
  ...required,
  message: "Questo campo è richiesto"
});

extend("exact_length", {
  params: ["length", "message"],
  validate(val, { length, message }) {
    if (val === false) {
      return message ?? "Questo campo è richiesto";
    }
    return true;
  }
});

configure({
    classes: {
        valid: 'is-valid',
        invalid: 'is-invalid',
        dirty: ['is-dirty', 'is-dirty'],
    }
});